import React from 'react';

interface SkillSearchResultsProps {
  searchedSkills: searchedSkills[];
  handleSkillSelect: (skill: searchedSkills) => void;
}

interface searchedSkills {
  _id: string;
  _source: {
    name: string;
  };
}

const SkillSearchResults: React.FC<SkillSearchResultsProps> = ({
  searchedSkills,
  handleSkillSelect,
}) => {
  return (
    <>
      <div className="skill_search_results">
        {searchedSkills?.map((skill) => (
          <div
            className="skill_blog"
            key={skill?._id}
            onClick={() => handleSkillSelect(skill)}
          >
            <div className="skill_bg">
              <img
                src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacbd_skills_icon.png"
                loading="lazy"
                alt=""
                className="image-220"
              />
            </div>
            <div>{skill?._source?.name}</div>
          </div>
        ))}
      </div>
    </>
  );
};

export default SkillSearchResults;
